const prepopulatedMentionEntityStrategy = (
  contentBlock,
  callback,
  contentState
) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'PREPOPULATED_MENTION'
    );
  }, callback);
};

export default prepopulatedMentionEntityStrategy;
